module.exports = __webpack_public_path__ + "static/media/canadawideSticker.83a0b188.svg";